<template>
    <div :class="['logout-dropdown', open ? 'shadowed' : '', disabled ? 'disabled-link' : '']" v-click-outside="closeDropdown">
        <div class="main-box" @click="clickDropdown()">
            <div class="user-icon">
                <img class="light-mode" v-if="(user.class == 'super-admin' || user.class == 'owner' || user.class == 'fulfilment' || user.class == 'support') && superAdminLogged" src="../assets/img/user-icon-sa-logged.svg"/>
                <img class="dark-mode" v-if="(user.class == 'super-admin' || user.class == 'owner' || user.class == 'fulfilment' || user.class == 'support') && superAdminLogged" src="../assets/img/user-icon-sa-logged-dark.svg"/>
                <img class="light-mode" v-if="user.class == 'customer-owner'" src="../assets/img/user-icon-black.svg"/>
                <img class="dark-mode" v-if="user.class == 'customer-owner'" src="../assets/img/user-icon-white.svg"/>
                <img v-if="(user.class == 'super-admin' || user.class == 'owner' || user.class == 'fulfilment' || user.class == 'support') && superAdminLogged == false" src="../assets/img/user-icon-pink.svg"/>
                <img v-else-if="user.class == 'administrator'" src="../assets/img/user-icon-red.svg"/>
                <img v-else-if="user.class == 'billing' || user.class == 'billing-reading'" src="../assets/img/user-icon-blue.svg"/>
                <img v-else-if="user.class == 'provisioning' || user.class == 'provisioning-reading'" src="../assets/img/user-icon-purple.svg"/>
            </div>
            <div class="username-role">
                <h3 class="username">{{user.name}}</h3>
                <h4 class="userrole">{{user.type}}</h4>
            </div>
            <i :class="['fa', open ? 'fa-caret-up' : 'fa-caret-down']"></i>
        </div>
        <div :class="['dropdown-content', open ? 'content-visible' : '']">
            <div v-if="superAdminLogged || isMCA" class="links-list">
                <div class="super-admin-logged">
                    <h3>You are logged in</h3>
                    <h4>{{companyLogged}}</h4>
                </div>
                <a v-if="isMCA == false" class="link" @click="logoutSuperAdmin">
                    <img src="../assets/img/user-icon-pink.svg"/>
                    <span>SA Dashboard</span>
                </a>
            </div>
            <div v-if="superAdminLogged == false" class="links-list">
                <a class="link" :href="userProfile">
                    <img class="light-mode" src="../assets/img/user-circle.svg"/>
                    <img class="dark-mode" src="../assets/img/user-circle-dark.svg"/>
                    <span>My profile</span>
                </a>
                <div v-if="isMCA" @click="logoutMCA()" class="link">
                    <img class="light-mode" src="../assets/img/mcaicon.svg"/>
                    <img class="dark-mode" src="../assets/img/mcaicondark.svg"/>
                    <span>Companies</span>
                </div>
                <a :href="SSOlink" v-if="keycloakLogged" class="link">
                    <img src="../assets/img/kore-circle.svg" alt="">
                    <span>SSO Dashboard</span>
                </a>
            </div>
            <div @click="logout()" :class="['logout-box', user.class]">
                <span>Logout</span>
                <img class="light-mode" src="../assets/img/logout-icon.svg">
                <img class="dark-mode" src="../assets/img/logout-icon-dark.svg">
            </div>
        </div>
        <MultiCompanyLogin v-if="MCAModal" :isLogin="false" @closeModal="closeModal()"></MultiCompanyLogin>
        <b-modal data-keyboard="false" id="session-expire" size="md" class="session-expire" centered title="Session Expiring" ref="session-expire" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
            <p>Your session is about to expire due to inactivity.</p>

            You will be automatically logged out in <strong>{{countSeconds}} seconds</strong>

            <button class="btn btn-success btn-block active" @click="continueSession">Continue session</button>
        </b-modal>
    </div>
</template>

<script>
import Vue from "vue";
import VueSession from "vue-session";
import VueCookies from "vue-cookies";
Vue.use(VueSession);
Vue.use(VueCookies);
import keycloak from "../main";
import Axios from "axios";
import globalStore from "@/variables";
import router from "@/router";
import MultiCompanyLogin from "./MultiCompanyLogin";
import VueJwtDecode from "vue-jwt-decode";



Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

export default {
    name: "LogoutDropdown",
    components: {
        MultiCompanyLogin
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            keycloakLogged: false,
            user: {
                type: '',
                class: '',
                name: ''
            },
            open: false,
            SSOlink: globalStore.data.keycloakHomeUrl,
            userProfile: '/#/user-profile',
            superAdminLogged: this.$session.get('companyId') ? true : false,
            companyLogged: this.$session.get('companyName'),
            MCAModal: false,
            isMCA: false,
            countSeconds: 60
        }
    },
    methods: {
        clickDropdown() {
            if (this.open) {
                this.open = false
            } else {
                this.open = true
            }
        },
        closeDropdown() {
            this.open = false
        },
        logoutSuperAdmin() {
            let companyId = this.$session.get('companyId');
            this.$session.remove('coldStockAccess');
            this.$session.remove('tier2Roaming');
            this.$session.remove('voiceAccess');
            this.$session.remove('hotSpotAccess');
            this.$session.remove('nbIoTPlans');
            this.$session.remove('catM1Plans');
            this.$session.remove('simonActiveReady');
            this.$session.remove('companyId');
            this.$session.remove('companyName');
            this.$session.remove('simonCarrierAvailable');
            this.$session.remove('tmobileCarrierAvailable');
            this.$session.remove('vodafoneCarrierAvailable')
            this.$session.remove('typeAccount');
            this.$session.remove('userId');
            if (this.$session.get('loggedFromList')) {
                this.$router.push("/admin/companies")
            } else {
                this.$router.push("/admin/company/" + companyId)
            }
        },
        logout() {
            if (this.$cookies.get('isSA') == 'false' && (keycloak.token || this.$cookies.get('token'))) {
                if (this.$cookies.get('simsMarked') == 'true') {
                    Axios.delete(globalStore.data.restApiUrl + "/sims/mark")
                        .then(response => {
                            this.$cookies.remove('token')
                            this.$cookies.remove('refreshToken')
                            this.$cookies.remove('refreshFlag')
                            this.$cookies.remove('lastActiviti')
                            this.$cookies.remove('multiCompanyAccess')
                            this.$cookies.remove('multiCompanyAccessId')
                            this.$cookies.remove('isSA')
                            this.$cookies.remove('tokenSetTime')
                            this.$cookies.remove('userId')
                            this.$cookies.remove('userLevelId')
                            this.$cookies.remove('userEmail')
                            this.$cookies.remove('userLevel')
                            this.$cookies.remove('permissions')
                            this.$cookies.remove('firstName')
                            this.$cookies.remove('lastName')
                            this.$cookies.remove('companyId')
                            this.$cookies.remove('companyName')
                            this.$cookies.remove('typeAccount')
                            this.$cookies.remove('simonCarrierAvailable')
                            this.$cookies.remove('tmobileCarrierAvailable')
                            this.$cookies.remove('vodafoneCarrierAvailable')
                            this.$cookies.remove('koreCarrierAvailable')
                            this.$cookies.remove('nbIoTPlans')
                            this.$cookies.remove('voiceAccess')
                            this.$cookies.remove('tier2Roaming')
                            this.$cookies.remove('catM1Plans')
                            this.$cookies.remove('simonActiveReady')
                            this.$cookies.remove('coldStockAccess')
                            this.$cookies.remove('hotSpotAccess')
                            this.$cookies.remove('acceptedAgreementId')
                            this.$cookies.set('logoutInProgress', true)
                            if (this.$cookies.get('defaultLogin') == 'false') {
                                this.$cookies.remove('defaultLogin')
                                if (this.$cookies.get('token')) {
                                    this.$cookies.remove('token')
                                } else {
                                    this.$session.remove('token')
                                }
                                keycloak.logout()
                            } else {
                                this.$cookies.remove('defaultLogin')
                                router.push('/login')
                            }
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Unselecting SIM cards on the server side failed.',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                } else {
                    this.$cookies.remove('token')
                    this.$cookies.remove('refreshToken')
                    this.$cookies.remove('refreshFlag')
                    this.$cookies.remove('lastActiviti')
                    this.$cookies.remove('multiCompanyAccess')
                    this.$cookies.remove('multiCompanyAccessId')
                    this.$cookies.remove('isSA')
                    this.$cookies.remove('tokenSetTime')
                    this.$cookies.remove('userId')
                    this.$cookies.remove('userLevelId')
                    this.$cookies.remove('userEmail')
                    this.$cookies.remove('userLevel')
                    this.$cookies.remove('permissions')
                    this.$cookies.remove('firstName')
                    this.$cookies.remove('lastName')
                    this.$cookies.remove('companyId')
                    this.$cookies.remove('companyName')
                    this.$cookies.remove('typeAccount')
                    this.$cookies.remove('simonCarrierAvailable')
                    this.$cookies.remove('tmobileCarrierAvailable')
                    this.$cookies.remove('vodafoneCarrierAvailable')
                    this.$cookies.remove('koreCarrierAvailable')
                    this.$cookies.remove('nbIoTPlans')
                    this.$cookies.remove('voiceAccess')
                    this.$cookies.remove('tier2Roaming')
                    this.$cookies.remove('catM1Plans')
                    this.$cookies.remove('simonActiveReady')
                    this.$cookies.remove('coldStockAccess')
                    this.$cookies.remove('hotSpotAccess')
                    this.$cookies.remove('acceptedAgreementId')
                    this.$cookies.set('logoutInProgress', true)
                    if (this.$cookies.get('defaultLogin') == 'false') {
                        this.$cookies.remove('defaultLogin')
                        if (this.$cookies.get('token')) {
                            this.$cookies.remove('token')
                        } else {
                            this.$session.remove('token')
                        }
                        keycloak.logout()
                    } else {
                        this.$cookies.remove('defaultLogin')
                        router.push('/login')
                    }
                }
            } else if (this.$session.get('isSA') && (keycloak.token || this.$session.get('token'))) {
                this.$session.destroy()
                if (this.$cookies.get('defaultLogin') == 'false') {
                    this.$cookies.remove('defaultLogin')
                    if (this.$cookies.get('token')) {
                        this.$cookies.remove('token')
                    } else {
                        this.$session.remove('token')
                    }
                    keycloak.logout()
                } else {
                    this.$cookies.remove('defaultLogin')
                    router.push('/login')
                }
            }
        },
        logoutMCA() {
            this.MCAModal = true
        },
        closeModal() {
            this.MCAModal = false
        },
        continueSession() {
            clearInterval(this.timerSeconds);
            let currentTime = Date.now()
            if (this.$cookies.get('isSA') == 'false') {
                this.$cookies.set('tokenSetTime', currentTime)
                this.$cookies.set('stopCounting', true, 60)
                this.$refs['session-expire'].hide();
            } else {
                if (this.$session.get('isSA')) {
                    this.$session.set('tokenSetTime', currentTime)
                    this.$refs['session-expire'].hide();
                }
            }
        },
        showModalExpire() {
            this.$refs['session-expire'].show();
            this.timerSeconds = setInterval(() => {
                if (keycloak.token) {
                    this.countSeconds = Math.round((this.logoutTime - Date.now()) / 1000)
                    if (this.logoutTime < Date.now()) {
                        this.logoutTime = null
                        if (this.$refs['session-expire']) {
                            this.$refs['session-expire'].hide();
                        }
                        sessionStorage.setItem('sessionExpired', true);
                        if(this.$session.get('isSA')) {
                            this.$cookies.set(this.$session.get('userEmail') + '-last-active-page',this.$route.path, '1h')
                            if (this.$session.get('companyId')) {
                                let loginData = {
                                    companyId: this.$session.get('companyId'),
                                    companyName: this.$session.get('companyName'),
                                    typeAccount: this.$session.get('typeAccount'),
                                    coldStockAccess: this.$session.get('coldStockAccess'),
                                    tier2Roaming: this.$session.get('tier2Roaming'),
                                    voiceAccess: this.$session.get('voiceAccess'),
                                    hotSpotAccess: this.$session.get('hotSpotAccess'),
                                    nbIoTPlans: this.$session.get('nbIoTPlans'),
                                    catM1Plans: this.$session.get('catM1Plans'),
                                    simonActiveReady: this.$session.get('simonActiveReady'),
                                    simonCarrierAvailable: this.$session.get('simonCarrierAvailable'),
                                    tmobileCarrierAvailable: this.$session.get('tmobileCarrierAvailable'),
                                    vodafoneCarrierAvailable: this.$session.get('vodafoneCarrierAvailable'),
                                    koreCarrierAvailable: this.$session.get('koreCarrierAvailable')
                                }
                                this.$cookies.set(this.$session.get('userEmail') + '-company-data', JSON.stringify(loginData), '1h')
                            }
                        }
                        this.logout()
                        clearInterval(this.timerSeconds);
                    } else if (this.$cookies.get('stopCounting') == 'true') {
                        clearInterval(this.timerSeconds);
                        if (this.cardIdle) {
                            this.startCounting();
                        }
                        if (this.$refs['session-expire']) {
                            this.$refs['session-expire'].hide();
                        }
                    }
                } else {
                    if (this.$refs['session-expire']) {
                        this.$refs['session-expire'].hide();
                    }
                    clearInterval(this.timerSeconds);
                    this.logout()
                }
            }, 1000)
        },
        startCounting() {
            this.counter = setInterval(() => {
                if (this.$session.get('token')) {
                    if (this.$session.get('logoutTime')) {
                        if (Date.now() + 90000 > this.$session.get('logoutTime')) {
                            clearInterval(this.counter)
                            this.countExpire();
                        }
                    }
                } else {
                    if (this.$cookies.get('logoutTime') != '') {
                        if (Date.now() + 90000 > Number(this.$cookies.get('logoutTime'))) {
                            clearInterval(this.counter)
                            this.countExpire();
                        }
                    }
                }
            }, 30000)
        },
        countExpire() {
            this.counter = setInterval(() => {
                if (this.$session.exists()) {
                    if (this.$session.get('logoutTime')) {
                        if (Date.now() + 60000 > this.$session.get('logoutTime')) {
                            clearInterval(this.counter)
                            this.logoutTime = this.$session.get('logoutTime')
                            this.showModalExpire()
                        }
                    }
                } else {
                    if (this.$cookies.get('logoutTime')) {
                        if (Date.now() + 60000 > Number(this.$cookies.get('logoutTime'))) {
                            clearInterval(this.counter)
                            this.logoutTime = Number(this.$cookies.get('logoutTime'))
                            this.showModalExpire()
                        }
                    }
                }
            }, 1000)
        },
        setLogoutTime() {
            if (this.$session.exists()) {
                this.$session.set('logoutTime', Date.now() + 900000);
            } else {
                this.$cookies.set('logoutTime', Date.now() + 900000);
            }
        },
        removeLogoutTime() {
            if (this.$session.exists()) {
                this.$session.remove('logoutTime')
            } else {
                this.$cookies.remove('logoutTime')
            }
        }
    },
    mounted() {
        this.keycloakLogged = this.$cookies.get('defaultLogin') == 'false' || this.$session.get('defaultLogin') == 'false'
        if (this.$session.get('token')) {
            this.user.name = this.$session.get('firstName') + ' ' + this.$session.get('lastName')
            this.user.type = this.$session.get('userLevel')
            this.user.class = this.$session.get('userLevel').replace(' ', '-').toLowerCase()
            this.userProfile = '/#/admin/admin-profile'
        } else {
            this.user.name = this.$cookies.get('firstName') + ' ' + this.$cookies.get('lastName')
            this.user.type = this.$cookies.get('userLevel')
            this.user.class = this.$cookies.get('userLevel').replace(' ', '-').toLowerCase()
            this.userProfile = '/#/user-profile'
        }

        this.isMCA = this.$cookies.get('multiCompanyAccess') == 'true'
        if (this.isMCA) {
            this.companyLogged = this.$cookies.get('companyName')
        }

        globalStore.data.EventBus.$on('updateUserInHeader', () => {
            this.user.type = this.$cookies.get('userLevel')
            this.user.class = this.$cookies.get('userLevel').replace(' ', '-').toLowerCase()
            this.companyLogged = this.$cookies.get('companyName')
        });
    },
    beforeUnmount() {
        if (this.$cookies.get('refreshFlag') == 'true') {
            this.$cookies.set('refreshFlag', false)
        }
        clearInterval(this.refreshTimer)
    },
    onActive() {
        this.cardIdle = false;
        if (this.logoutTime == null) {
            this.removeLogoutTime();
        }
        clearInterval(this.counter)

        if (this.$cookies.get('token') || this.$session.get('token')) {
            const token = this.$cookies.get('token') ? this.$cookies.get('token') : this.$session.get('token')
            const tokenDecoded = VueJwtDecode.decode(token)
            let d = new Date(tokenDecoded.exp * 1000)
            if (new Date() > d) {
                const refreshToken = this.$cookies.get('refreshToken') ? this.$cookies.get('refreshToken') : this.$session.get('refreshToken');
                const refreshDecoded = VueJwtDecode.decode(refreshToken)
                if (new Date(refreshDecoded.expires_at * 1000) > new Date()) {
                    Axios.post(globalStore.data.restApiUrl + `/refresh?grant_type=refresh_token&refresh_token=${refreshToken}`)
                        .then(response => {
                            if (this.$cookies.get('token')) {
                                this.$cookies.set("token", response.data.accessToken);
                                this.$cookies.set('refreshToken', response.data.refreshToken);
                            } else if (this.$session.get('token')) {
                                this.$session.set("token", response.data.accessToken);
                                this.$session.set('refreshToken', response.data.refreshToken);
                            }
                        })
                } else {
                    this.logout()
                }
            }
        }
    },
    onIdle() {
        this.cardIdle = true;
        this.setLogoutTime()
        if (this.$refs['session-expire'].isShow == false) {
            this.startCounting();
        }
    }
}
</script>

<style lang="scss">
.logout-dropdown {
    position: relative;
    min-width: 260px;
    margin: 0 30px;
    &.disabled-link {
        a {
            opacity: 0.5;
            pointer-events: none !important;
        }
    }
    &.shadowed {
        box-shadow: 0 0 0 #d6d6d6,
        0 3px 6px #d6d6d6,
        0 0 0 #d6d6d6,
        0 3px 6px #d6d6d6;
    }
    .main-box {
        display: flex;
        align-items: center;
        min-width: 230px;
        padding: 10px 24px;
        cursor: pointer;
        .user-icon {
            margin: 0 16px 0 0;
            .light-mode {
                display: initial;
            }
            .dark-mode {
                display: none;
            }
        }
        .username-role {
            flex-grow: 1;
            margin: 0 24px 0 0;
            .username {
                margin: 0;
                font-size: 14px;
            }

            .userrole {
                margin: 0;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }
    .dropdown-content {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        display: none;
        flex-direction: column;
        gap: 12px 0;
        padding: 10px 0 0;
        background-color: #fff;
        box-shadow: 0 0 0 #d6d6d6,
        0 3px 6px #d6d6d6,
        0 3px 6px #d6d6d6,
        0 3px 6px #d6d6d6;
        &.content-visible {
            display: flex;
        }
        .links-list {
            display: flex;
            flex-direction: column;
            padding: 0 8px;
            gap: 12px 0;
            .link {
                display: flex;
                align-items: center;
                width: 100%;
                padding: 13px 16px;
                -webkit-border-radius: 6px;
                -moz-border-radius: 6px;
                border-radius: 6px;
                text-decoration: none;
                cursor: pointer;
                &:hover {
                    background-color: #f6f6f6;
                }
                img {
                    width: 20px;
                    height: 20px;
                    margin: 0 24px 0 0;
                    &.light-mode {
                        display: initial;
                    }
                    &.dark-mode {
                        display: none;
                    }
                }
                span {
                    font-size: 16px;
                    color: #484848;
                }
            }
            .super-admin-logged {
                padding: 12px 20px;
                background-color: #F5F5F5;
                -webkit-border-radius: 6px;
                -moz-border-radius: 6px;
                border-radius: 6px;
                h3 {
                    margin: 0 0 6px;
                    font-size: 14px;
                    color: #6B6B6B;
                    text-align: center;
                    font-weight: 400;
                }
                h4 {
                    margin: 0;
                    font-size: 14px;
                    text-align: center;
                    font-weight: 400;
                }
            }
        }
        .logout-box {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0 12px;
            padding: 14px;
            color: #484848;
            background-color: #f9f9f9;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            img {
                &.light-mode {
                    display: initial;
                }
                &.dark-mode {
                    display: none;
                }
            }

            &:hover {
                color: #ffffff;
                img {
                    &.light-mode {
                        display: none;
                    }
                    &.dark-mode {
                        display: initial;
                    }
                }
            }

            &.administrator:hover {
                background-color: #fc4d4d;
            }

            &.provisioning:hover,
            &.provisioning-reading:hover {
                background-color: #c84dfc;
            }

            &.billing:hover,
            &.billing-reading:hover {
                background-color: #747fe2;
            }

            &.customer-owner:hover {
                background-color: #000;
            }

            &.super-admin:hover,
            &.owner:hover,
            &.fulfilment:hover,
            &.support:hover {
                background-color: #fc4de5;
            }
        }
    }
}

@media screen and (max-width: 450px) {
    .logout-dropdown {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        margin: 0;
    }
}

.dark-theme {
    .logout-dropdown {
        color: #fff;

        &.shadowed {
            box-shadow: 0 0 0 #2f353a,
            0 3px 6px #2f353a,
            0 0 0 #2f353a,
            0 3px 6px #2f353a;
        }
        .main-box {
            .user-icon {
                .light-mode {
                    display: none;
                }

                .dark-mode {
                    display: initial;
                }
            }
        }

        .dropdown-content {
            background-color: #3a4149;
            box-shadow: 0 0 0 #2f353a,
            0 3px 6px #2f353a,
            0 3px 6px #2f353a,
            0 3px 6px #2f353a;
            .links-list {
                .super-admin-logged {
                    background-color: #515b65;
                    h3 {
                        color: #9D9D9D;
                    }
                }
                .link {
                    &:hover {
                        background-color: #2f353a;
                    }
                    span {
                        color: #fff;
                    }
                    img {
                        &.light-mode {
                            display: none;
                        }
                        &.dark-mode {
                            display: initial;
                        }
                    }
                }
            }
            .logout-box {
                background-color: #515b65;
                color: #fff;
                img {
                    &.light-mode {
                        display: none;
                    }
                    &.dark-mode {
                        display: initial;
                    }
                }
            }
        }
    }
}
</style>